// A font family is valid unquoted in CSS only if every word is an identifier.
// "Baloo 2" and "Source Sans 3" are not (a word starts with a digit), so the
// browser silently DROPS `font-family: Baloo 2` and the text renders in the
// inherited UI font (Roboto) on the canvas and in Times on the export server.
// Quote such names; plain names and font stacks pass through unchanged so
// already-working fonts serialize exactly as before.
// Its own module (re-exported from index.js) so light modules such as the PSD
// text layout can use it without pulling in index.js's whole import graph.
export const cssFontFamily = (family) =>
  !family ||
  /[,"']/.test(family) ||
  /^\s*-?[A-Za-z_][\w-]*(\s+-?[A-Za-z_][\w-]*)*\s*$/.test(family)
    ? family
    : `"${family}"`;
